import { Directive, forwardRef, Renderer2, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const UPPERCASE_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UppercaseDirective),
  multi: true
};

@Directive({
  selector: '[uppercase]',
  host: {
    '(input)': 'onInput($event.target.value)',
    '(blur)': 'onBlur()'
  },
  providers: [UPPERCASE_VALUE_ACCESSOR]
})
export class UppercaseDirective implements ControlValueAccessor {

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    elementRef.nativeElement.style.textTransform  = 'uppercase';
  }
  
  public onChange = (_: any) => {};
  
  public onTouched = () => {};
  
  public registerOnChange(fn: (value: any) => any): void { 
    this.onChange = fn; 
  }

  public registerOnTouched(fn: () => any): void { 
    this.onTouched = fn; 
  }

  public onBlur() {
    this.onTouched();
  }
  
  public onInput(value: string) {
    const formatted: any = this.formatValue(value);
    
    this.onChange(formatted);
  }
  
  public writeValue(value: any): void {
    const formatted: any = this.formatValue(value);
    
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
  }
  
  private formatValue(value: any): string {
    return value && typeof value === 'string' ?
      value.toUpperCase() :
      '';
  }

}
